module.exports = __webpack_public_path__ + "img/hierarchy.e6e3b489.svg";